// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"2adfbbbf","152":"2c22c43a","198":"99fca25a","345":"bf5b4ae8","362":"e83e6b87","404":"3ac5f455","473":"f05674c0","480":"73ff2fe8","485":"06e06f08","541":"36c4cf9f","549":"2c9abd0d","579":"d98de613","622":"12771674","639":"47bb708c","854":"10515221"}[chunkId] + ".chunk.js";
};